import { render, staticRenderFns } from "./ScheduleClassesCombo.vue?vue&type=template&id=005e56c6&scoped=true"
import script from "./ScheduleClassesCombo.vue?vue&type=script&lang=js"
export * from "./ScheduleClassesCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005e56c6",
  null
  
)

export default component.exports